import { inject } from '@angular/core';
import type { SurveyResult } from '../models/survey-result.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

export class SurveyService {
  private readonly httpClient = inject(HttpClient);

  public async survey(result: SurveyResult) {
    const headers = new HttpHeaders({ 'X-Survey': result.hash ?? '' });
    return lastValueFrom(this.httpClient.post('/HelplineServer/api/Survey/SurveyResult', result, { headers }));
  }
}
